<template>
    <el-dialog class="setting" title="聊天模式设置" :visible.sync="visible" width="620px" :before-close="onClose">
        <el-form :model="chatModeInfo" label-width="80px" :rules="rules" ref="chatModeForm" size="small">
            <el-form-item label="聊天模式">
                <el-radio-group v-model="chatModeInfo.chatMode">
                    <el-radio :label="0">人工</el-radio>
                    <el-radio :label="1">AI自动回复</el-radio>
                    <el-radio :label="2">固定回复</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button :loading="loading" @click="onClose()">取 消</el-button>
            <el-button :loading="loading" type="primary" @click="onSubmit()">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: 'setting',
        components: {},
        data() {
            return {
                loading: false,
                chatModeInfo: {
                    id: '',
                    chatMode: 0
                },
                rules: {
                    chatMode: [
                        {
                            required: true,
                            message: '请选择聊天模式',
                            trigger: 'blur'
                        }
                    ]
                }
            };
        },
        methods: {
            onClose() {
                this.$emit('close');
            },

            onSubmit() {
                this.$refs['chatModeForm'].validate((valid) => {
                    if (!valid) {
                        return false;
                    }
                    this.loading = true;
                    this.$http({
                        url: '/client/modifyChatMode',
                        method: 'post',
                        data: this.chatModeInfo
                    })
                        .then(() => {
                            this.$emit('close');
                            this.$message.success('修改成功');
                            this.$store.dispatch('loadAccount');
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                });
            },
            onUploadSuccess(data, file) {
                this.userInfo.headImage = data.originUrl;
                this.userInfo.headImageThumb = data.thumbUrl;
            }
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            account: {
                type: Object,
                default: () => {}
            }
        },
        computed: {
            imageAction() {
                return `/image/upload`;
            }
        },
        watch: {
            visible: function (newData, oldData) {
                // 深拷贝
                this.chatModeInfo = { ...this.account };
            }
        }
    };
</script>

<style lang="scss">
    .setting {
        .el-form {
            padding: 10px 0 0 10px;
        }

        .avatar-uploader {
            --width: 112px;

            .el-upload {
                border: 1px dashed #d9d9d9 !important;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }

            .el-upload:hover {
                border-color: #409eff;
            }

            .avatar-uploader-icon {
                font-size: 24px;
                color: #8c939d;
                width: var(--width);
                height: var(--width);
                line-height: var(--width);
                text-align: center;
            }

            .avatar {
                width: var(--width);
                height: var(--width);
                display: block;
            }
        }
    }
</style>
